import { useSelector } from 'react-redux'
import { generatePath } from 'react-router'
import * as Sentry from '@sentry/browser'
import { ROUTES } from 'constants/routes'

const useGeneratePathI18n = () => {
  const { i18n } = useSelector(({ app }) => app)

  return (route = '', params = {}) => {
    try {
      return generatePath(route, { i18n, ...params })
    } catch (err) {
      Sentry.captureException(
        'path generation error! params:' + JSON.stringify(params) + ', route:' + route,
      )
      return generatePath(ROUTES.SERVICES, { i18n })
    }
  }
}

export default useGeneratePathI18n
